"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _contentHelpers = _interopRequireDefault(require("../../helpers/contentHelpers"));

var _LinkedContentMapper = _interopRequireDefault(require("../LinkedContentMapper/LinkedContentMapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var infoListConfig = {
  listItem: 'WithCheckmark',
  embed: 'inline'
};
/* eslint-disable camelcase */

var InfoList = function InfoListComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData,
      linkedContent = _ref.linkedContent;
  var linkedContentData = (0, _contentHelpers["default"])(sliceData, linkedContent);
  var _sliceData$primary = sliceData.primary,
      background_color = _sliceData$primary.background_color,
      info_list_title = _sliceData$primary.info_list_title,
      items = sliceData.items;
  var info_list_body = items[0].info_list_body;
  var backgroundColor = background_color;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-list-wrapper info-list-wrapper--divider",
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-list-title-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "info-list-body__heading-2"
  }, dataClient.textToMarkdown(info_list_title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-list-body-col"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    content: info_list_body,
    baseClass: "info-list-body",
    options: infoListConfig
  }), /*#__PURE__*/_react["default"].createElement(_LinkedContentMapper["default"], {
    linkedContentData: linkedContentData,
    dataClient: dataClient
  })))));
};

InfoList.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      background_color: _propTypes["default"].string,
      info_list_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    }),
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  linkedContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    content: _propTypes["default"].shape({
      image_links: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      cta_button: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      content_box: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    })
  }))
};
InfoList.defaultProps = {
  linkedContent: null
};
var _default = InfoList;
exports["default"] = _default;